export const updateTabTitle = (newTitle: string) => {
  return (document.title = `${newTitle} | AEL Tracker`);
};
